import React from "react";
import PropTypes from "prop-types";
import LogoContainer from "../components/logoContainer";
import SidebarOrders from "../components/SidebarOrders";
import { showSidebarCollapseFunction, hideSidebarCollapseFunction } from "../components/SidebarFunctions";
import { windowHistoryReplaceState } from "../components/mainFunctions";
import OrdersDashboard from "./ordersDashboard/OrdersDashboard";

const Orders = ({ token, independent, instanceType, language }) => {
    const content = <OrdersDashboard token={token} independent={independent} instanceType={instanceType} language={language} />;

    windowHistoryReplaceState(independent, instanceType);

    let flag = 0;
    const showSidebarCollapse = () => {
        if (document.querySelector(".sidebar2Collapse")) {
            showSidebarCollapseFunction();
            flag = 1;
        }
    };

    const hideSidebarCollapse = () => {
        if (flag === 1) {
            hideSidebarCollapseFunction();
            flag = 0;
        }
    };

    return (
        <div className="tab-pane fade" id="nav-controlOrders" role="tabpanel" aria-labelledby="nav-controlOrders-tab" style={{ opacity: 1 }}>
            <nav
                className="sidebar2"
                aria-label="Orders"
                onPointerEnter={showSidebarCollapse}
                onPointerLeave={hideSidebarCollapse}
            >
                <LogoContainer />
                <SidebarOrders />
            </nav>
            <div className="content" id="contentOrders">
                {content}
            </div>
        </div>
    );
};

Orders.propTypes = {
    token: PropTypes.string,
    independent: PropTypes.string,
    instanceType: PropTypes.string,
    language: PropTypes.string.isRequired
};

Orders.defaultProps = {
    token: "",
    independent: "",
    instanceType: ""
};

export default Orders;
